import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getActiveIntegrationErrors} from '../../../../store/data/dataSelectors';
import {initializeIntegrationErrorsAction} from '../../../../store/data/integrations/integrationErrorsActions';
import {IntegrationErrorBanners} from './integrationErrorBanners';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  errors: getActiveIntegrationErrors,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onMount: initializeIntegrationErrorsAction,
}));

export const IntegrationErrorBannersContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(IntegrationErrorBanners);
